(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nekupi-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nekupi-back-to-top')) {
    customElements.define('nekupi-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const button = this.querySelector('button');
        const wrapper = document.querySelector('.page-wrapper');
        const update = () => { button.hidden = Math.max(window.scrollY, wrapper?.scrollTop || 0) < 400; };
        document.addEventListener('scroll', update, { capture: true, passive: true, signal });
        window.addEventListener('pageshow', update, { signal });
        button.addEventListener('click', () => {
          const target = document.querySelector('#MainContent');
          if (target) {
            const previous = target.getAttribute('tabindex');
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
            target.addEventListener('blur', () => {
              if (previous === null) target.removeAttribute('tabindex');
              else target.setAttribute('tabindex', previous);
            }, { once: true });
          }
          const options = { top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' };
          wrapper?.scrollTo(options);
          window.scrollTo(options);
        }, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekupi-cart-recommendation"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'nekupi-cart-last-reading';
  function choose(root) {
    if (root.querySelector('[data-random-selected]')) return;
    const cards = Array.from(root.querySelectorAll('[data-random-candidate]'));
    if (!cards.length) return;
    let last = '';
    try { last = sessionStorage.getItem(storageKey) || ''; } catch {}
    const alternatives = cards.filter(card => card.dataset.randomCandidate !== last);
    const pool = alternatives.length ? alternatives : cards;
    const selected = pool[Math.floor(Math.random() * pool.length)];
    cards.forEach(card => { card.hidden = card !== selected; });
    selected.dataset.randomSelected = 'true';
    try { sessionStorage.setItem(storageKey, selected.dataset.randomCandidate); } catch {}
    const selectedLink = selected.querySelector('.nk-cart-rec__info > a');
    if (selectedLink) {
      document.querySelectorAll('.nk-cart-goal .nk-cart-rec__card').forEach(card => {
        const link = card.querySelector('.nk-cart-rec__info > a');
        card.hidden = !!link && new URL(link.href, location.href).pathname === new URL(selectedLink.href, location.href).pathname;
      });
    }
  }
  let scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('.nk-cart-random').forEach(choose);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekupi-club-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.getElementById('nc-widget'),dialog=root?.querySelector('.nc-dialog'),launcher=root?.querySelector('.nc-launch'),frame=root?.querySelector('.nc-account-frame');
  if(!dialog||!launcher||!frame||root.dataset.panelReady)return;
  root.dataset.panelReady='true';let oldOverflow='';
  launcher.addEventListener('click',()=>{if(dialog.open)return;oldOverflow=document.body.style.overflow;frame.src=frame.dataset.src;dialog.showModal();document.body.style.overflow='hidden';launcher.setAttribute('aria-expanded','true');dialog.querySelector('.nc-close').focus();});
  root.querySelector('.nc-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
  dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;launcher.setAttribute('aria-expanded','false');launcher.focus({preventScroll:true});});
})();

(() => {
  const root = document.getElementById('nc-widget');
  if (!root?.dataset.collectionProduct || root.dataset.collectionReady) return;
  let context;
  try { context = JSON.parse(root.querySelector('.nc-context').textContent); } catch { return; }
  root.dataset.collectionReady = 'true';
  const productId = root.dataset.collectionProduct;
  const endpoint = root.dataset.endpoint.replace(/\/$/, '') + '/collection';
  const loginUrl = '/account/login?return_url=' + encodeURIComponent(endpoint);
  let state = context.loggedIn ? 'loading' : 'guest', busy = false, scheduled = false, collectionData = null;
  const originals = new WeakMap();
  const labels = new Set(['Añadir al carrito', 'Encargar', 'Agregar al carrito']);
  const text = {
    owned: ['✓ En tu colección', 'Ver colección ↗'],
    missing: ['Aún no está en tu colección', 'Ver colección ↗'],
    guest: ['Tu colección, siempre a mano', 'Inicia sesión para verla ↗'],
    loading: ['Consultando tu colección…', 'Ver colección ↗'],
    error: ['No se ha podido consultar tu colección', 'Ver colección ↗']
  };
  function apply() {
    const owned = state === 'owned';
    const info = document.querySelector('[id^="ProductInformation-"]');
    const main = info?.querySelector('button[name="add"]');
    const buttons = [main, document.querySelector('sticky-add-to-cart .sticky-add-to-cart__button')].filter(Boolean);
    for (const button of buttons) {
      const nested = button.querySelector('.add-to-cart-text__content > span:first-child');
      const node = nested?.firstChild || Array.from(button.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
      if (!node) continue;
      const current = node.textContent.trim();
      if (owned && !button.disabled && labels.has(current)) {
        originals.set(button, current);
        node.textContent = current === 'Encargar' ? 'Encargar otra unidad' : 'Comprar otra unidad';
      } else if (!owned && originals.has(button) && ['Comprar otra unidad', 'Encargar otra unidad'].includes(current)) {
        node.textContent = originals.get(button);
      }
    }
    const sticky = document.querySelector('sticky-add-to-cart');
    const stickyInfo = sticky?.querySelector('.sticky-add-to-cart__info');
    const stickyButton = sticky?.querySelector('.sticky-add-to-cart__button');
    let stickyNote = sticky?.querySelector('.nc-sticky-owned');
    if (stickyInfo && !stickyNote) {
      stickyNote = document.createElement('span');stickyNote.className = 'nc-sticky-owned';stickyInfo.append(stickyNote);
    }
    if (stickyNote && stickyNote.dataset.state !== state) {
      stickyNote.dataset.state = state;
      stickyNote.textContent = state === 'guest' ? 'Inicia sesión para ver tu colección' : text[state][0];
    }
    if (stickyButton && !stickyButton.disabled) {
      if (owned) {
        stickyButton.setAttribute('aria-label', stickyButton.textContent.includes('Encargar otra unidad') ? 'Encargar otra unidad: ya está en tu colección' : 'Comprar otra unidad: ya está en tu colección');
        stickyButton.dataset.collectionLabel = 'true';
      } else if (stickyButton.dataset.collectionLabel) {
        stickyButton.removeAttribute('aria-label');delete stickyButton.dataset.collectionLabel;
      }
    }
    let note = document.getElementById('nc-product-owned');
    if (main && !note) {
      note = document.createElement('div');note.id = 'nc-product-owned';note.setAttribute('role', 'status');
      note.append(document.createElement('strong'), document.createElement('a'));
      const container = main.closest('add-to-cart-component') || main;container.before(note);
    }
    if (note && note.dataset.state !== state) {
      note.dataset.state = state;
      note.querySelector('strong').textContent = text[state][0];
      const link = note.querySelector('a');link.href = state === 'guest' ? loginUrl : endpoint;link.textContent = text[state][1];
    }
  }
  function schedule() {
    if (scheduled) return;scheduled = true;
    requestAnimationFrame(() => { scheduled = false; apply(); });
  }

  function showAlertControl() {
    const old=document.getElementById('nc-product-restock');
    const legacy=document.querySelectorAll('a[href*="/pages/avisame-cuando-llegue"]');
    const product=collectionData?.series?.flatMap(s=>s.volumes||[]).find(p=>p.id===productId);
    const guestEmpty=state==='guest'&&root.dataset.collectionStock==='empty';
    if(!guestEmpty&&(!product||product.owned||!product.active||product.stock>0)){old?.remove();legacy.forEach(a=>a.removeAttribute('data-collection-alert-replaced'));return;}
    const enabled=!guestEmpty&&(collectionData?.alertSubscriptions||[]).some(s=>s.kind==='restock'&&s.target===productId);
    const signature=String(guestEmpty)+'|'+String(enabled);if(old?.dataset.signature===signature)return;
    const wasOpen=old?.open;old?.remove();
    const note=document.getElementById('nc-product-owned');if(!note)return;
    const box=document.createElement('details');box.id='nc-product-restock';box.dataset.signature=signature;box.open=!!wasOpen;
    const summary=document.createElement('summary');
    summary.textContent=enabled?'✓ Aviso de reposición activado':'Avísame cuando vuelva a estar en stock';box.append(summary);
    if(guestEmpty){const a=document.createElement('a');a.href=loginUrl;a.textContent='Inicia sesión para activar el aviso';box.append(a);}
    else {
      const form=document.createElement('form');const label=document.createElement('label');const check=document.createElement('input');check.type='checkbox';check.required=!enabled;
      if(!enabled){label.append(check,document.createTextNode(' Quiero recibir un correo cuando este tomo vuelva a estar en stock.'));form.append(label);}
      const help=document.createElement('p');help.textContent='Puedes desactivarlo cuando quieras. Los correos requieren una cuenta suscrita a promociones.';
      const button=document.createElement('button');button.type='submit';button.textContent=enabled?'Desactivar aviso':'Activar aviso por correo';
      const result=document.createElement('p');result.setAttribute('role','status');form.append(help,button,result);box.append(form);
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(!enabled&&!check.checked)return;button.disabled=true;
        try{const response=await fetch(endpoint,{method:'POST',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'notify',kind:'restock',target:productId,enabled:!enabled,consent:!enabled,token:collectionData.token})});
          const out=await response.json();if(!response.ok)throw new Error(out.error||'No se ha podido guardar el aviso.');collectionData=out;showAlertControl();const updated=document.getElementById('nc-product-restock');if(updated)updated.open=true;
        }catch(e){result.textContent=e.message;button.disabled=false;}
      });
    }
    note.after(box);legacy.forEach(a=>a.setAttribute('data-collection-alert-replaced','true'));
  }

  async function refresh() {
    if (!context.loggedIn) { state = 'guest';apply();showAlertControl();return; }
    if (busy) return;busy = true;
    const controller = new AbortController();const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(endpoint + '?format=json', {credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if (response.status === 401) { state = 'guest';apply();showAlertControl();return; }
      if (!response.ok) throw new Error('collection');
      const result = await response.json();if (!Array.isArray(result.series)) throw new Error('collection');
      collectionData=result;
      state = result.series.some(series => series.volumes?.some(volume => volume.id === productId && volume.owned === true)) ? 'owned' : 'missing';apply();showAlertControl();
    } catch { state = 'error';apply();document.getElementById('nc-product-restock')?.remove(); } finally { clearTimeout(timeout);busy = false; }
  }
  const info = document.querySelector('[id^="ProductInformation-"]');
  if (info) new MutationObserver(schedule).observe(info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
  document.addEventListener('visibilitychange',() => {if(document.visibilityState==='visible')refresh();});
  window.addEventListener('pageshow',event => {if(event.persisted)refresh();});
  apply();refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekupi-cookie-preferences"] && !Shopify.designMode) return;
  try {
    class NekupiCookiePreferences extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    this.status = this.querySelector('[data-cookie-status]');
    this.querySelector('[data-cookie-open]').addEventListener('click',event=>{event.preventDefault();this.openPreferences();},{signal});
    this.querySelector('[data-cookie-close]').addEventListener('click',()=>this.dialog.close(),{signal});
    this.form.addEventListener('submit',event=>{event.preventDefault();this.save();},{signal});
    this.querySelectorAll('[data-cookie-choice]').forEach(button=>button.addEventListener('click',()=>{
      this.form.querySelectorAll('input[name]').forEach(input=>input.checked=button.dataset.cookieChoice==='accept');
      this.save();
    },{signal}));
  }
  disconnectedCallback() { this.controller?.abort(); }
  async loadApi() {
    if (window.Shopify?.customerPrivacy) return window.Shopify.customerPrivacy;
    if (!window.Shopify?.loadFeatures) throw new Error('Privacy unavailable');
    await new Promise((resolve,reject)=>{
      const timeout=setTimeout(()=>reject(new Error('Privacy timeout')),8000);
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{clearTimeout(timeout);error?reject(error):resolve();});
    });
    return window.Shopify.customerPrivacy;
  }
  async openPreferences() {
    if (this.opening) return;
    this.opening=true;
    try {
      if (window.privacyBanner?.showPreferences) {
        try {await window.privacyBanner.showPreferences();return;} catch {}
      }
      this.status.textContent='';
      this.dialog.showModal();
      this.api=await this.loadApi();
      const consent=this.api.currentVisitorConsent();
      this.form.querySelectorAll('input[name]').forEach(input=>{input.checked=consent[input.name]==='yes';input.disabled=false;});
      this.form.querySelectorAll('button').forEach(button=>button.disabled=false);
    } catch {this.status.textContent=this.dataset.error;}
    finally {this.opening=false;}
  }
  async save() {
    if (!this.api || this.saving) return;
    this.saving=true;this.status.textContent='';
    this.form.querySelectorAll('button').forEach(button=>button.disabled=true);
    const consent={};
    this.form.querySelectorAll('input[name]').forEach(input=>{consent[input.name]=input.checked;});
    try {
      await new Promise((resolve,reject)=>{
        const timeout=setTimeout(()=>reject(new Error('Consent timeout')),8000);
        this.api.setTrackingConsent(consent,()=>{clearTimeout(timeout);resolve();});
      });
      const saved=this.api.currentVisitorConsent();
      if (!Object.entries(consent).every(([key,value])=>saved[key]===(value?'yes':'no'))) throw new Error('Consent not saved');
      this.status.textContent=this.dataset.saved;
    } catch {this.status.textContent=this.dataset.error;}
    finally {this.saving=false;this.form.querySelectorAll('button').forEach(button=>button.disabled=false);}
  }
}
if (!customElements.get('nekupi-cookie-preferences')) customElements.define('nekupi-cookie-preferences',NekupiCookiePreferences);
  } catch(e) { console.error(e); }
})();

})();
